import styled from "styled-components";
const DividerH = styled.hr`
  margin: 0px;
  border: 0;
  border-top: ${(props) => (props.size ? props.size : "1px")} solid
    ${(props) => (props.color ? props.color : "#cdd4de")};
`;

export default DividerH;
